
<template>
      <div class="car-gong car-con">
            <div class="title">
                <img src="//www.ule.com/app/yxd/event/2019/0730/nianhj/images/jika/t2.png" alt="">
            </div>
            <div class="gong-content">
                <img :src="ifylxd?'//www.ule.com/app/yxd/event/2019/0730/nianhj/images/jika/ylxd.png':'//www.ule.com/app/yxd/event/2019/0730/nianhj/images/jika/ule.png'" alt="">
            </div>
        </div>
</template>

<script>
export default {
  props:['ifylxd'],  
}
</script>

<style scoped>
.car-con{
    width: 100%;
    overflow: hidden;
    padding-bottom: .5rem;
}
.car-con .title{
    width: 100%;
    text-align: center;
}
.car-con .title img{
    height: .88rem;
    width:auto;
    display: inline-block;
}
/* 活动规则 */
.car-gong .gong-content{
    display: block;
    text-align: center;
    margin-top: .36rem;
}
.car-gong .gong-content img{
    width: 94%;
    display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/components/commont/strategy.vue